import * as React from "react";

export class EventCard extends React.Component<{ eventId: string, modifiers?: string }, {}> {

    eventCardClasses: string;
    constructor(props) {
        super(props);
        this.eventCardClasses = "rj-event-card" + ((this.props.modifiers) ? ` ${this.props.modifiers}` : "");
    }

    render() {

        return (
            <div className={this.eventCardClasses} data-uat="event-wrapper-inner" data-mastereventid={this.props.eventId}>
                {this.props.children}
            </div>
        )
    }
}